module.exports = __webpack_public_path__ + "static/img/yeswecan0002.6bb9886.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0002.png
// module id = 577
// module chunks = 1